// extracted by mini-css-extract-plugin
module.exports = {"icon":"SportMarcatoriTableStats_icon__omkDd","container":"SportMarcatoriTableStats_container__nTQ_4"};